module.exports = __webpack_public_path__ + "img/logo_isolutions.2a82afb5.png";